// extracted by mini-css-extract-plugin
export default {"col":"FormColWrapper_col__yIdLZ"};